import { render, staticRenderFns } from "./ReplyNewSpouseSupport.vue?vue&type=template&id=2e2c40e0"
import script from "./ReplyNewSpouseSupport.vue?vue&type=script&lang=ts"
export * from "./ReplyNewSpouseSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports